

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedOption, addResumenData, removeResumenData, updateDominioPrincipal } from '../../globalslice';
import '../../styles/Agregado.scss';
import { useTranslation } from 'react-i18next';
import bsqicon from '../../images/bsq-icon.svg';
import bsqicon2 from '../../images/bsq-icon-orange.svg';

const DominioAgregado = () => {
  const [icon, setIcon] = useState(bsqicon);
  const [inputError, setInputError] = useState('');
  const [dominioAgregado, setDominioAgregado] = useState('');
  const [dominiosAgregado, setDominiosAgregado] = useState([]);
  const selectedOption = useSelector((state) => state.global.selectedOption);
  const dispatch = useDispatch();
  const resumenData = useSelector((state) => state.global.ResumenData);
  const { t } = useTranslation();


  useEffect(() => {
    // Extraemos los dominios ya asignados a otro producto o servicio
    const assignedDomains = resumenData
      .filter((item) => item.product.domain_section && item.product.domain_section[0]?.dominio_principal && item.type!='domain')
      .map((item) => item.product.domain_section[0].dominio_principal);

    // Filtramos para obtener solo los dominios no asignados
    const availableDomains = resumenData
      .filter(
        (item) =>
          item.actual === false &&
          item.type === 'domain' &&
          item.product.domain_section &&
          !assignedDomains.includes(item.product.domain_section[0]?.dominio_principal)
      )
      .map((item) => item.product.domain_section[0]?.dominio_principal);

    setDominiosAgregado(availableDomains);
  }, [resumenData]);
  
  const handleOptionChange = (option) => {
    dispatch(setSelectedOption(option));
    if(option === 'opc-agregado'){
      resumenData.forEach(element => {
        if(element.actual && element.type != 'domain'){
          dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:null, domainType: null }));
        } else if(element.actual && element.type == 'domain'){
          dispatch(removeResumenData(element.id));
        }
      });
    }  else {
      setDominiosAgregado([]);
      setDominioAgregado('');
    }
  };

  //cambia el dominio seleccionado cambio a la variable que guarda el elemento
  const handleAgregadoChange = async (event) => {
    resumenData.forEach(element => {
      if(element.product.domain_section[0]?.dominio_principal == event.target.value){
        setDominioAgregado(element);
      }
    });
  };

  //modifico el servicio para asignarle este dominio como dominio principal
  const handleDominioPrincipal = async () => {
    if (dominioAgregado != ''){
      resumenData.forEach(element => {
        if(element.actual && element.type != 'domain'){
          dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:dominioAgregado.product.domain_section[0]?.dominio_principal, domainType: 'register' }));
        }
      });
    }
  };
  return (
    dominiosAgregado.length > 0 && (
      <div className={`bsq-dominio ${selectedOption === 'opc-agregado' ? 'active' : ''}`}>
        <div className='bsq-radio'>
          <input
            type="radio"
            className=""
            name="sel-type"
            id="opc-agregado"
            checked={selectedOption === 'opc-agregado'}
            onChange={() => handleOptionChange('opc-agregado')}
          />
          <label className="opc-busqueda" htmlFor="opc-agregado">{t('cart.config.domain.agregado.label')}</label>
          <div className={`contenido-busqueda ${selectedOption !== 'opc-agregado' ? 'bsq-hidden' : ''}`}>
            <div className='bsq-buscador'>
              <div className="input-container">
                <img src={icon} alt="Icon Busqueda" className="bsq-search-icon" />
                <select className='bsq-input-agregado'
                  id="bsq-input-agregado"
                  label=""
                  onFocus={() => setIcon(bsqicon2)} 
                  onBlur={() => setIcon(bsqicon)} 
                  onChange={handleAgregadoChange} >
                  <option key='' value=''> </option>
                  {dominiosAgregado.map((domain) => (
                    <option key={domain} value={domain}>
                      {domain}
                    </option>
                  ))}
                </select>
              </div>
              <button className="bsq-btn-buscar" onClick={handleDominioPrincipal}>{t('cart.config.domain.agregado.btn')}</button>
            </div>
          </div>
        </div>  
      </div>
    )
  );
}

export default DominioAgregado;
